<template>
    <div slot="content">
        <div class="table-area">
            <div class="table-b">
                <div class="grid-tbl-box">
                    <ag-grid-vue 
                        ref="grid" 
                        :style="gridStyle"
                        class="ag-theme-alpine"
                        :column-defs="columnDefs"
                        :grid-options="gridOptions"
                        :row-data="data"
                        :default-col-def="defaultColDef"
                        :framework-components="frameworkComponent"
                        :enableRangeSelection="true"
                        @grid-ready="onReady"
                        @cell-clicked="onCellClicked" />
                </div>
            </div>
        </div>
        <!-- 모델정보 s. -->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">모델정보</h3>
                    </div>
                    <div class="btn-wrap">
                      <el-form size="mini">
                        <el-form-item>
                          <el-button type="primary" icon="el-icon-document-add" style="float: right;" v-show="showModelInfo" @click="asProcessSave('MODEL')">저장</el-button>
                          <el-button type="warning" icon="el-icon-document-copy" style="float: right;" v-show="showModelInfo" @click="searchModel('modelInfo')">변경</el-button>
                        </el-form-item>
                      </el-form>
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue
                            ref="subGrid"
                            :style="subGridStyle"
                            class="ag-theme-alpine"
                            :column-defs="modelColumnDefs"
                            :grid-options="modelGridOptions"
                            :row-data="tableModelInfo"
                            :default-col-def="defaultColDef"
                            :enableRangeSelection="true"
                            :framework-components="frameworkComponent"
                            :stopEditingWhenCellsLoseFocus="true"
                            @cell-value-changed="modelGridCellValueChange"
                            @grid-ready="onReadyModel"/>
                    </div>
                </div>
            </div>
        </div>
        <!-- 모델정보 e. -->
        <!-- 장애내역 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">장애내역</h3>
                </div>
                <el-table :data="tableTroubleData" style="width: 100%">
                    <el-table-column prop="breakGb" label="증상구분" width="160"></el-table-column>
                    <el-table-column prop="breakHst" label="고장증상" width="380"> </el-table-column>
                    <el-table-column prop="breakDtl" label="상세증상" width="530"> </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 장애내역 e. -->
        <!-- 유/무상 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">유/무상</h3>
                </div>
                <el-form>
                    <el-row :gutter="24">
                        <el-col :span="4">
                            <el-form-item label="접수:">
                                <el-input v-model="payYnNm" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="처리:">
                                <el-select v-model="payYn" @change="onPayYnChange" :disabled="changePayYn">
                                    <el-option
                                        v-for="item in payYnList"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <el-form-item label="변경사유">
                                <el-row>
                                    <el-col :span="24">
                                        <el-col :span="6">
                                            <el-select v-model="changePayYnCd" v-show="changePayYnCdShow" :disabled="changePayYn">
                                                <el-option
                                                    v-for="item in changePayYnCdList"
                                                    :key="item.value"
                                                    :label="item.value"
                                                    :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                        <el-col :span="18">
                                            <el-input v-model="changePayYnMemo" @change="(val) => changePayYnMemo = val" :disabled="changePayYn"></el-input>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <!-- 유/무상 e. -->
        <!-- 접수/처리유형 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">접수/처리유형</h3>
                </div>
                <el-form>
                    <el-row :gutter="24">
                        <el-col :span="4">
                            <el-form-item label="접수:">
                                <el-input v-model="asClassNm" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="처리:">
                                <el-select v-model="changeAsClassCd" @change="onChangeAsClassCdChange" :disabled="changePayYn">
                                    <el-option
                                        v-for="item in changeAsClassCdList"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <el-form-item label="변경사유">
                                <el-row>
                                    <el-col :span="24">
                                        <el-col :span="6">
                                             
                                        </el-col>
                                        <el-col :span="18">
                                            <el-input v-model="changeAsClassMemo" @change="(val) => changeAsClassMemo = val" :disabled="changePayYn"></el-input>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <!-- 접수/처리유형 e. -->
        
        <!-- 고장원인 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-header">
                    <div class="table-name">
                      <h3 class="ico_table_name">고장원인</h3>
                    </div>
                    <div class="btn-wrap">
                      <el-form size="mini">
                        <el-form-item>
                          <el-button type="danger" icon="el-icon-delete" style="float: right;" v-show="showFailureCause" @click="deleteFailureCauseRow">삭제</el-button>
                          <el-button type="primary" icon="el-icon-plus" style="float: right;" v-show="showFailureCause" @click="failureCauseModal">추가</el-button>
                        </el-form-item>
                      </el-form>
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue
                            ref="subGrid"
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            :column-defs="failureCauseColumnDefs"
                            :grid-options="failureCauseGridOptions"
                            :row-data="tableFailureCause"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            :enableRangeSelection="true"
                            @grid-ready="onReadyFailureCause"
                            />
                    </div>
                </div>
            </div>
        </div>
        <!-- 고장원인 e. -->

        <!-- 수리내역 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-header">
                    <div class="table-name">
                      <h3 class="ico_table_name">수리내역</h3>
                    </div>
                    <div class="btn-wrap">
                      <el-form size="mini">
                        <el-form-item>
                          <el-button type="danger" icon="el-icon-delete" style="float: right;" v-show="showRepair" @click="deleteRepairCatRow">삭제</el-button>
                          <el-button type="primary" icon="el-icon-plus" style="float: right;" v-show="showRepair" @click="repairCatModal">추가</el-button>
                        </el-form-item>
                      </el-form>
                  </div>
                </div>
                <div class="grid-tbl-box">
                  <ag-grid-vue
                      ref="subGrid"
                      :style="gridStyle"
                      class="ag-theme-alpine"
                      :column-defs="repairColumnDefs"
                      :grid-options="repairGridOptions"
                      :row-data="tableAsRepair"
                      :default-col-def="defaultColDef"
                      :framework-components="frameworkComponent"
                      :enableRangeSelection="true"
                      :stopEditingWhenCellsLoseFocus="true"
                      @grid-ready="onReadyRepair"
                  />
                </div>
            </div>
        </div>
        <!-- 수리내역 e. -->

        <!-- 사용/회수자재 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-header">
                    <div class="table-name">
                    <h3 class="ico_table_name">사용/회수자재</h3>
                    </div>
                    <div class="btn-wrap">
                      <el-form size="mini">
                        <el-form-item>
                          <el-button type="danger" icon="el-icon-delete" style="float: right;" v-show="showRepairItem" @click="deleteUseMateRow">삭제</el-button>
                          <el-button type="primary" icon="el-icon-plus" style="float: right;" v-show="showRepairItem" @click="useMateSelectModal">추가</el-button>
                        </el-form-item>
                      </el-form>
                    </div>
                    <div class="grid-tbl-box">
                      <ag-grid-vue
                          ref="subGrid"
                          :style="gridStyle"
                          class="ag-theme-alpine"
                          :column-defs="repairItemColumnDefs"
                          :grid-options="repairItemGridOptions"
                          :row-data="tableAsRepairItem"
                          :default-col-def="defaultColDef"
                          :framework-components="frameworkComponent"
                          :enableRangeSelection="true"
                          :stopEditingWhenCellsLoseFocus="true"
                          @cell-value-changed="onCellValueChanged"
                          @grid-ready="onReadyRepairItem"
                      />
                    </div>
                </div>
            </div>
        </div>
        <!-- 사용/회수자재 e. -->

        <!-- 교환모델 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-header">
                    <div class="table-name">
                    <h3 class="ico_table_name">교환모델</h3>
                    </div>
                    <div class="btn-wrap">
                      <el-form size="mini">
                        <el-form-item>
                          <el-button type="danger" icon="el-icon-delete" style="float: right;" v-show="showChangeModel" @click="deleteChangeModelRow">삭제</el-button>
                          <el-button type="primary" icon="el-icon-plus" style="float: right;" v-show="showChangeModel" @click="searchModel('changeModel')">추가</el-button>
                        </el-form-item>
                      </el-form>
                    </div>
                    <div class="grid-tbl-box">
                      <ag-grid-vue
                          ref="subGrid"
                          :style="subGridStyle"
                          class="ag-theme-alpine"
                          :column-defs="modelItemColumnDefs"
                          :grid-options="modelItemGridOptions"
                          :row-data="tableChangeModel"
                          :default-col-def="defaultColDef"
                          :framework-components="frameworkComponent"
                          :enableRangeSelection="true"
                          :stopEditingWhenCellsLoseFocus="true"
                          @cell-value-changed="modelItemGridCellValueChange"
                          @grid-ready="onReadyModelItem"
                      />
                    </div>
                </div>
            </div>
        </div>
        <!-- 교환모델 e. -->

        <!-- 미처리사유 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">미처리사유</h3>
                </div>
                <el-form>
                    <el-row :gutter="24">
                        <el-col :span="4">
                            <el-form-item>
                                <el-select v-model="asStatus" :disabled="asStatusEditable">
                                    <el-option
                                        v-for="item in asStatusList"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="20">
                            <el-form-item>
                                <el-input v-model="asStatusMemo" @change="(val) => asStatusMemo = val" :disabled="asStatusEditable"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <!-- 미처리사유 e. -->

        <!-- 특기사항, 수리비 s. -->
        <div class="talbe-contain" style="display: flex;">
            <div class="table-area" style="margin-right: 50px; width: 50%;">
                <div class="table-a">
                    <div class="table-name">
                    <h3 class="ico_table_name">특기사항</h3>
                    </div>
                    <el-form>
                        <el-row :gutter="24">
                            <el-col :span="24">
                                <el-form-item>
                                    <el-input
                                        type="textarea"
                                        :readonly="readCatDescriptionEditable"
                                        :autosize="{ minRows: 4, maxRows: 6}"
                                        placeholder="특기사항을 작성하세요."
                                        v-model="catDescription">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <div class="table-area" style="margin-right: 0px; width: 80%;">
                <div class="table-a">
                    <div class="table-name">
                    <h3 class="ico_table_name">수리비</h3>
                    </div>

                    <div class="grid-tbl-box">
                      <ag-grid-vue
                          ref="subGrid"
                          :style="subGridStyle"
                          class="ag-theme-alpine"
                          :column-defs="costRepairColumnDefs"
                          :grid-options="costRepairGridOptions"
                          :row-data="tableRepair"
                          :default-col-def="defaultColDef"
                          :framework-components="frameworkComponent"
                          :enableRangeSelection="true"
                          :stopEditingWhenCellsLoseFocus="true"
                          @grid-ready="onReadyCostRepair"
                      />
                    </div>
                </div>
            </div>
        </div>
        <!-- 특기사항, 수리비 e. -->

        <!-- 현장사진 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">현장사진</h3>
                </div>
                <el-table
                    :data="fieldImgList"
                    style="width: 100%;cursor: pointer;" 
                    @row-click="viewImg">
                    <el-table-column prop="originalName" label="파일명" align="center" width="230"> </el-table-column>
                    <el-table-column prop="downloadUrl" label="파일경로" align="center" width="558">
                        <template slot-scope="scope">
                            <el-tag
                            :type="scope.row.downloadUrl === '' ? 'primary' : 'success'"
                            disable-transitions>{{scope.row.downloadUrl}}</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 현장사진 e. -->

        <div class="table-a">
          <el-form>
            <el-row>
              <el-col :span="4">
                <el-button type="primary" icon="el-icon-document" v-show="showAsSaveValidate" @click="asProcessSave('SAVE')">
                    진행중
                </el-button>
              </el-col>  
              <el-col :span="5">
                <el-button type="warning" icon="el-icon-edit-outline" v-show="showItemRequestValidate" @click="asProcessSave('REQ')">
                    자재요청
                </el-button>
              </el-col>  
              <el-col :span="8" v-if="showAsCompleteValidate && changeAsClassCd=='Cancel'">  
                <el-form-item label="문자발송">
                  <el-radio-group v-model="smsYn">
                      <el-radio 
                          v-for="item in smsYnRadio"
                          :key="item.key"
                          :label="item.key"
                          :value="item.key">{{ item.value }}
                      </el-radio>
                  </el-radio-group>
                  &nbsp;
                  <el-button type="danger" icon="el-icon-edit-outline" @click="asProcessSave('PROC')">
                      AS완료
                  </el-button>
                </el-form-item>
              </el-col>
              <el-col :span="4" v-else>  
                <el-button type="danger" icon="el-icon-edit-outline" v-show="showAsCompleteValidate" @click="asProcessSave('PROC')">
                    AS완료
                </el-button>
              </el-col> 
              <el-col :span="4">
                <el-button type="info" icon="el-icon-document" @click="goPrint">
                  접수내역서
                </el-button>
              </el-col>  
            </el-row>
          </el-form>
        </div>
    </div>
</template>

<script>
//import ReqMateEnterModal from "@/components/LucomsModal/ReqMateEnterModal";
import ReqMateEnterModal from "@/components/LucomsModal/ReqMateEnter";
import RequestMateEnterModal from "@/components/LucomsModal/RequestMateEnterModal";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

/**
 * * mixins
 */
 import lucoms from '@/mixin/lucoms';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';
//import DatepickerCellRenderer from '@/components/agGrid/datepicker-cell-renderer';
import DatepickerCellRenderer from '@/components/elementUI/datepicker-cell-renderer';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';
import InputCellRender from '@/components/agGrid/input-cell-renderer';
import FailureCauseSelect from '@/components/LucomsModal/FailureCauseSelect.vue';
import FieldImgModal from '@/components/AS/CallTreat/Modal/ProcsHst/FieldImgModal.vue';
import UseMateSelectModal from '@/components/LucomsModal/UseMateSelectModal.vue';
import RecallMateSelectModal from '@/components/LucomsModal/RecallMateSelectModal.vue';
import RepairCatSelect from '@/components/LucomsModal/RepairCatSelect.vue';
import ModelSelectModal from '@/components/AS/NormalConsult/Modal/ModelSelectModal.vue';
import ProductMenu from '@/components/AS/Receipt/Modal/ProductMenu.vue';
import ProcsHstPrint from "@/components/AS/CallTreat/Modal/ProcsHst/ProcsHstPrint";

//import DefectJudgmentModal from '@/components/AS/CallTreat/Modal/ProcsHst/DefectJudgmentModal.vue';

export default {
    mixins: [lucoms],
    components: {AgGridVue, DhxCalendar},
    data() {
        return {
            asId: '',
            data: [],
            subData: [], /** 고장원인 */
            payYnCd: '', /** 유/무상 코드*/
            payYnNm: '', /** 유/무상 명*/
            payYn: '', /** 유/무상 */
            payYnList: [{key: '', value: ''}], /** 유/무상 */
            payYnIdList: [{key: '', value: ''}], /** 유/무상 */
            payYnLoadCnt: 0,
            changePayYnCdList: [{key: '', value: ''}], /** 유/무상 변경사유*/
            changePayYnCdShow: false,
            changePayYnCd: '',
            changePayYnMemo: '', /** 변경사유 메모 */
            asClassNm: '',    /** 접수명 */
            changeAsClassCd: '',    /** 접수/처리유형 변경사유 코드*/
            changeAsClassCdInit: '', /** 접수/처리유형 변경사유 코드*/
            changeAsClassCdList: [{key: '', value: ''}], /** 접수/처리유형 */
            changeAsClassMemo: '',  /** 접수/처리유형 변경사유 */
            costType : '',  // 내근, 외근 구분
            asStatus: '', /** 미처리사유 */
            asStatusReal: '', /** 미처리사유(DB에 저장된 값) */
            asStatusList: [{key: '01', value: 'test'}],
            asStatusMemo: '', /** 미처리사유 */
            catDescription: '', /** 특기사항 */
            selProcIdx: -1, /** 처리내역에서 선택된 Index 번호 */
            tabCacheLoadData: {},  /** tab을 클릭시 셋팅된 데이타 : AS접수모델 클릭시 재로딩하면 시간이 걸려서 캐싱하여서 로딩시키기 위해 */
            fieldImgList: [{fileNm: 'test1.jpg', savedFilePath: '/image/fieldimg/2023/img0001.jpg'}], /** 현장사진 */

            changePayYn : false, /** 유/무상 disabled true, false **/
            showFailureCause: false, /** 고장원인 추가/삭제 버튼 표시유무 */
            showModelInfo : false, /** 모델정보 변경/저장 버튼 표시유무 */
            showRepair : false, /** 수리내역 추가/삭제 버튼 표시유무 */
            showRepairItem : false, /** 사용/회수자재 추가/삭제 버튼 표시유무 */
            showChangeModel : false, /** 교환모델 추가/삭제 버튼 표시유무 */
            showAsSaveValidate: false, /** 진행중 */
            showItemRequestValidate: false, /** 자재요청 */
            showAsCompleteValidate: false, /** AS완료 */

            tableModelInfo:[],  /** 모델정보 **/
            tableModelInfoList:[],  /** 모델정보 리스트**/
            tableTroubleData: []/** 장애내역 */,
            tableFailureCause: []/** 고장원인 */,
            tableFailureCauseDel : [], /** 고장원인 삭제 **/
            tableFailureCauseList: []/** 고장원인 리스트*/,
            tableAsRepair: []/** 수리내역 */,
            tableAsRepairList: []/** 수리내역 리스트*/,
            tableAsRepairDel: [], /** 수리내역 삭제**/
            tableAsRepairItem: []/** 사용/회수자재 */,
            tableAsRepairItemList : [] /** 사용/회수자재 리스트*/,
            tableAsRepairItemDel: [], /** 사용/회수자재 삭제 **/
            tableChangeModel: []/** 교환모델 */,
            tableChangeModelDel: [] /** 교환모델 삭제 */,
            tableChangeModelList : [] /** 교환모델 리스트 */,
            tableRepair: []/** 수리비 */,
            tableRepairList: []/** 수리비 리스트 */,
            smsYn: 'Y',
            smsYnRadio: [{key: 'Y', value: '발송'},{key: 'N', value: '미발송'}],
             
            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 0px; width: 100%;height: 200px; min-height:100px;',
            subGridStyle : 'padding-top: 0px; width: 100%;height: 100px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter:false
                , sortable: true
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [],
            modelColumnDefs: [],
            failureCauseColumnDefs: [],
            repairColumnDefs: [],
            repairItemColumnDefs: [],
            modelItemColumnDefs: [],
            costRepairColumnDefs: [],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            modelGridOptions: {
              enableColResize: true,
              enableFilter: true,
              animateRows: false,
              enableSorting: true,
            },
            failureCauseGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            repairGridOptions: {
              enableColResize: true,
              enableFilter: true,
              animateRows: false,
              enableSorting: true,
            },
            repairItemGridOptions: {
              enableColResize: true,
              enableFilter: true,
              animateRows: false,
              enableSorting: true,
            },
            modelItemGridOptions: {
              enableColResize: true,
              enableFilter: true,
              animateRows: false,
              enableSorting: true,
            },
            costRepairGridOptions: {
              enableColResize: true,
              enableFilter: true,
              animateRows: false,
              enableSorting: true,
            },
            frameworkComponent : {
                datePicker: DatepickerCellRenderer,
                checkBox: CheckboxCellRenderer,
                input: InputCellRender,
            },
            //AG-GRID OPTION [END]
            itemQtyEditable:false,               /** 사용/회수 자재 수량 **/
            asStatusEditable:false,              /** 미처리사유 **/
            readCatDescriptionEditable: true,    /** 특기사항 **/
            //changeModelEditable : false,         /** 교환모델 **/
            costRepairEditable : false,          /** 실청구금액 **/
            outItemValue: true,
            totalAmt : ''                    /** 실청구금액 값 **/
        }
    },
    watch: {
        payYnLoadCnt(){
            //console.log('watch passed, ', this.payYnLoadCnt, this.changePayYnCd, this.changeAsClassCdInit)
            if(this.payYnLoadCnt === 2){
                /** 초기 로딩시에만 값 셋팅 */
                this.changePayYnCd = this.changeAsClassCdInit
            }
        }
    },
    mounted() {
        //console.log('this.$parent: ', this.$parent)
        this.getCombo({flag: 'INIT'})
        this.$emit("loadTab", {"tabNm":"2", "index": 0})
        console.log('===mounted ====', this)
    },
    methods: {
        onReady() {
            this.gridApi = this.gridOptions.api;
            this.columnApi = this.gridOptions.columnApi;
            this.createColumnDefs();
        },
        onReadyModel() {
          this.createModelColumnDefs();
        },
        onReadyFailureCause() {
          this.createFailureCauseColumnDefs();
        },
        onReadyRepair() {
          this.createRepairColumnDefs();
        },
        onReadyRepairItem() {
          this.createRepairItemColumnDefs();
        },
        onReadyModelItem() {
          this.createModelItemColumnDefs();
        },
        onReadyCostRepair() {
          this.createCostRepairColumnDefs();
        },
        getCombo(param) {
            if(param.flag === 'INIT'){
                // 유/무상 처리
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 353}}) // ChangePayYn
                    .then(response => {
                        this.payYnList = response.data || []
                        this.payYnLoadCnt++
                        //console.log('payYnList data :', response.data )
                    });

                // 유/무상 처리
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 353}}) // ChangePayYn
                    .then(response => {
                        this.payYnIdList = response.data || []
                        this.payYnLoadCnt++
                        //console.log('payYnList data2 :', response.data )
                    });

                // 접수/처리유형
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 344}}) // ChangeAsClass
                    .then(response => {
                        this.changeAsClassCdList = response.data.filter(x => x.key !== 'Return') || []
                    });

                // 미처리사유
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 385}}) // AsStatus
                    .then(response => {
                        this.asStatusList = response.data || []
                    });

            } else {
                /** 접수와 처리 값이 다른경우 변경 변경사유 활성화  **/
                if(this.payYnCd === 'Y' && param.parentId === '354') {
                  /** 354 무상 **/
                  this.changePayYnCdShow =  true
                } else if (this.payYnCd === 'N' && param.parentId === '355') {
                  /** 355 유상 **/
                  this.changePayYnCdShow =  true
                } else {
                  this.changePayYnCdShow =  false
                  this.changePayYnMemo = ''
                }

                // 변경사유
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                    .then(response => {
                      this.changePayYnCdList = response.data || []
                      this.changePayYnCdList.unshift({key:'', value:'전체'})
                      this.changePayYnCd = ''
                    });
            }

        },
        createColumnDefs() {
            this.columnDefs = [
                {headerName:'선택', field:'chk', width:50,
                    cellStyle: (params) => {
                        return params.rowIndex === this.selProcIdx ? {textAlign: 'center', backgroundColor: '#D5E6A3'} : {textAlign: 'center'}
                    },
                    cellRenderer: 'checkBox',
                    ellRendererParams: {
                          trueValue: true    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: false  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                },
                {headerName:'순번', field:'no', width:80,
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    },
                    cellStyle: (params) => {
                        return params.rowIndex === this.selProcIdx ? {textAlign: 'center', backgroundColor: '#D5E6A3'} : {textAlign: 'center'}
                    }
                },
                {headerName:'제조사', field:'makerNm', width:180,
                    cellStyle: (params) => {
                        return params.rowIndex === this.selProcIdx ? {textAlign: 'left', backgroundColor: '#D5E6A3'} : {textAlign: 'left'}
                    }
                },
                {headerName:'제품군', field:'modelGroupNm', width:200,
                    cellStyle: (params) => {
                        return params.rowIndex === this.selProcIdx ? {textAlign: 'left', backgroundColor: '#D5E6A3'} : {textAlign: 'left'}
                    }
                },
                {headerName:'모델', field:'modelNm', width:220,
                    cellStyle: (params) => {
                        return params.rowIndex === this.selProcIdx ? {textAlign: 'left', backgroundColor: '#D5E6A3'} : {textAlign: 'left'}
                    },
                    cellRenderer: (params) => {
                        return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
                    }
                },
                {headerName:'제조번호', field:'serialNo', width:200,
                    cellStyle: (params) => {
                      return params.rowIndex === this.selProcIdx ? {textAlign: 'left', backgroundColor: '#D5E6A3'} : {textAlign: 'left'}
                    }
                },
                {headerName:'구입년월', field:'purchaseDt', width:130,
                    valueGetter: (params) => {
                      if (params.data.purchaseDt.length >= 10) {
                        return params.data.purchaseDt.substring(0, 7)
                      }
                    },
                    cellStyle: (params) => {
                        return params.rowIndex === this.selProcIdx ? {textAlign: 'center', backgroundColor: '#D5E6A3'} : {textAlign: 'center'}
                    }
                },
            ];
        },
        createModelColumnDefs() {
          this.modelColumnDefs = [
            {headerName:'제조사', field:'makerNm', width:200, cellStyle:{textAlign:'left'}},
            {headerName:'제품군', field:'modelGroupNm', width:200, cellStyle:{textAlign:'left'}},
            {headerName:'모델', field:'modelNm', width:200, cellStyle:{textAlign:'left'}},
            {headerName:'제조번호', field:'serialNo', width:200, cellStyle:{textAlign:'left'},
              editable: (params) => {
                if(this.showModelInfo){
                  return true
                }else{
                  return false
                }
              }
            },
            {
              headerName:'제조년월', field:'prodDt', width:130, cellRenderer: 'datePicker',
              cellRendererParams: {
                // 참고 문서 : https://element.eleme.io/#/en-US/component/date-picker#attributes
                type: 'month',
                format: 'yyyy-MM',  //date format
                valueFormat: 'yyyyMM',  //받는 model 의 결과 포맷
                disable: false,
              },
            },
            {headerName:'구입년월', field:'purchaseDt', width:130, cellRenderer: 'datePicker'},
          ];
        },
        createFailureCauseColumnDefs() {
            this.failureCauseColumnDefs = [
                {headerName:'입력/수정', field:'ioFlag', width:100, cellStyle:{textAlign: 'center'}, hide:true},
                {headerName:'선택', field:'chk', width:80, cellStyle:{textAlign: 'center'}, cellRenderer: 'checkBox',
                    ellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                },
                {headerName: '원인구분', field:'asFailureCauseCat1', width: 180, cellStyle:{textAlign:'left'}},
                {headerName: '원인명', field:'asFailureCauseCatNm', width: 250, cellStyle:{textAlign:'left'}},
                {headerName: '상세원인명', field:'description', width: 550, cellRenderer: 'input', cellStyle:{textAlign:'left'},
                    cellRendererParams: {
                        obj: {
                            placeholder: "상세원인을 입력하세요."
                        }
                    }
                },
                {headerName: 'AS_CAT_ID', field:'asCatId', hide: true, suppressToolPanel: true}
            ];
        },
        createRepairColumnDefs() {
          this.repairColumnDefs = [
            {headerName:'입력/수정', field:'ioFlag', width:100, cellStyle:{textAlign: 'center'}, hide:true},
            {headerName:'선택', field:'chk', width:80,cellStyle:{textAlign: 'center'}, cellRenderer: 'checkBox',
              ellRendererParams: {
                trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                , disable: true
              },
            },
            {headerName: '증상구분', field:'asRepairCat1', width: 120, cellStyle:{textAlign:'left'}},
            {headerName: '고장증상', field:'asRepairCat2', width: 220, cellStyle:{textAlign:'left'}},
            {headerName: '고장부위', field:'asRepairCat3', width: 220, cellStyle:{textAlign:'left'}},
            {headerName: '기술료', field:'tmpAsRepairAmt', width: 150, cellStyle:{textAlign:'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName: '기술료_값_보관용', field:'asRepairAmt', suppressToolPanel: true, hide: true},
            {headerName: '상세수리내역', field:'description', width: 280, cellRenderer: 'input', cellStyle:{textAlign:'left'},
              cellRendererParams: {
                obj: {
                  placeholder: "상세수리내역을 입력하세요."
                }
              }
            },
            {headerName: 'REPAIR_CAT_ID', field:'asRepairCatId', hide: true, suppressToolPanel: true},
          ];
        },
        createRepairItemColumnDefs() {
          this.repairItemColumnDefs = [
            {headerName:'입력/수정', field:'ioFlag', width:100, cellStyle:{textAlign: 'center'}, hide:true},
            {headerName:'선택', field:'chk', width:80,cellStyle:{textAlign: 'center'}, cellRenderer: 'checkBox',
              ellRendererParams: {
                trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                , disable: true
              },
            },
            {headerName: '사용품번', field:'itemCd', width: 160, cellStyle:{textAlign:'left'}},
            {headerName: '사용품명', field:'itemNm', width: 160, cellStyle:{textAlign:'left'}},
            {headerName: '수량', field:'itemQty', width: 80, cellStyle:{textAlign: 'right', backgroundColor: '#fff8f7'},
              editable: (params) => {
                if(this.itemQtyEditable){
                  return true
                }else{
                  return false
                }
              },
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName: '단가', field:'unitPrice3', width: 100, cellStyle:{textAlign:'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName: '금액', field:'itemAmt3', width: 100, cellStyle:{textAlign:'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName: '회수품번', field:'recallItemCd', width: 160, cellStyle:{textAlign:'left'}},
            {headerName: '회수품명', field:'recallItemNm', width: 150, cellStyle:{textAlign:'left'}},
            {headerName: '수량', field:'recallItemQty', width: 80, cellStyle:{textAlign:'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName: 'ITEM_ID', field:'itemId', hide: true, suppressToolPanel: true},
            {headerName: 'RECALL_ITEM_ID', field:'itemId', hide: true, suppressToolPanel: true}
          ];
        },
        createModelItemColumnDefs() {
          this.modelItemColumnDefs = [
            {headerName:'모델', field:'changeModelNm', width:430, cellStyle:{textAlign:'left'}},
            {headerName:'제조번호', field:'changeSerialNo', width:430, cellStyle:{textAlign:'left'},
              editable: (params) => {
                if (this.showChangeModel) {
                  return true
                } else {
                  return false
                }
              }
            },
            {headerName:'제조년월', field:'changeProdDt', width:200, cellRenderer: 'datePicker',
              editable: (params) => {
                if (this.showChangeModel) {
                  return true
                } else {
                  return false
                }
              }
            },
          ];
        },
      createCostRepairColumnDefs() {
        this.costRepairColumnDefs = [
          {headerName:'자재비', field:'asRepairUnitFee', width:150, cellStyle:{textAlign:'right'},
            valueFormatter: (params) => {
              return this.getNumberFormat(params.value);
            }},
          {headerName:'기술료', field:'asRepairFee', width:150, cellStyle:{textAlign:'right'},
            valueFormatter: (params) => {
              return this.getNumberFormat(params.value);
            }},
          {headerName:'청구금액', field:'asRepairFeeAmt', width:150, cellStyle:{textAlign:'right'},
            valueFormatter: (params) => {
              return this.getNumberFormat(params.value);
            }},
          {headerName:'실청구금액', field:'asRepairFeeAmtReal', width:160,
            valueFormatter: (params) => {
              return this.getNumberFormat(params.value);
            },
            editable: (params) => {
              if (this.costRepairEditable) {
                return true
              } else {
                return false
              }
            },
            cellStyle: (params) => {
              if(this.costRepairEditable){
                return {textAlign: 'right', backgroundColor: '#fff8f7'};
              } else {
                return {textAlign: 'right'};
              }
            },
          },
      ];
      },
        changeProcsHstInfo(param, index){
            console.log('ProcsHst changeProcsHstInfo start param : ', param)

            this.tableFailureCauseDel = [];  // 고장원인 삭제내역 초기화
            this.tableAsRepairDel = [];      // 수리내역 삭제내역 초기화
            this.tableAsRepairItemDel = [];  // 사용/회수자재 삭제내역 초기화

            this.tabCacheLoadData = param;
            
            this.asId = param.asId || '';
            const vAsDetailId = param.asDetailId || '';
            const vAsProcessId = param.asProcessId || '';
            const vRepairId = param.repairId || '';

            if(vAsDetailId === '') return false;

            if(param.callAsProcessSel1List){
                let vProdDt = param.callAsProcessSel1List[index].prodDt
                if(vProdDt && vProdDt.length > 10 ){
                    vProdDt = vProdDt.substring(0, 10)
                }

                let vPurchaseDt = param.callAsProcessSel1List[index].purchaseDt
                if(vPurchaseDt && vPurchaseDt.length > 10 ){
                    vPurchaseDt = vPurchaseDt.substring(0, 10)
                }

                // 모델정보
                this.tableModelInfo = param.callAsProcessSel1List
                    .filter(x=>x.asDetailId===vAsDetailId && x.asProcessId===vAsProcessId)
                    .map(y=>{
                        return {
                                maker : y.maker,
                                makerNm : y.makerNm,
                                modelGroup : y.modelGroup,
                                modelId : y.modelId,
                                modelGroupNm : y.modelGroupNm,
                                modelNm: y.modelNm,
                                serialNo: y.serialNo,
                                prodDt: y.prodDt && y.prodDt.length >= 10 ? y.prodDt.substring(0,10): '',
                                purchaseDt: y.purchaseDt && y.purchaseDt.length>=10 ? y.purchaseDt.substring(0,10): '',
                                changePayYnCd : y.changePayYnCd,
                                payYn : y.payYn
                            };
                    }) || [];
                this.tableModelInfoList = param.callAsProcessSel1List
                /*************************************************************************/
                /***************************  유무상 정보 시작 ***************************/
                /*************************************************************************/
                let changeParentId

                let vChangePayYnCd = this.tableModelInfo[0].changePayYnCd  // 변경처리코드
                let vPayYn = this.tableModelInfo[0].payYn  // 접수

                // 접수와 처리가 같은 경우
                if((vPayYn === vChangePayYnCd) || vChangePayYnCd === '') {
                  this.changePayYnCdShow = false // 처리
                  this.payYn = vPayYn
                  this.changePayYnCd = vChangePayYnCd
                } else {
                  // 접수와 처리가 다른경우
                  this.changePayYnCdShow = true  // 처리

                  const changePayYnObj = param.getTopkey.filter(x => x.catKey === vChangePayYnCd && vChangePayYnCd.length > 1) || []

                  //변경처리코드가 있는경우 (접수 <> 처리)
                  if(changePayYnObj.length > 0){
                    this.payYn = changePayYnObj[0].parentId === 354 ? 'N' : 'Y'
                    this.changePayYnCd = changePayYnObj[0].catKey
                    changeParentId = changePayYnObj[0].parentId
                  } else {
                    this.payYn = vChangePayYnCd
                    changeParentId = vChangePayYnCd === 'Y' ? 355 : 354
                  }
                  //변경사유 리스트 재호출 (Todo 일단 재호출하고.. 리펙토링 할 것)
                  this.$http.get(`/api/codeMng/combo`, {params: {parentId: changeParentId}})
                      .then(response => {
                        this.changePayYnCdList = response.data || []
                        this.changePayYnCdList.unshift({key:'', value:'전체'})
                      });

                }
                // 유무상 변경사유
                this.changePayYnMemo = param.callAsProcessSel1List[index].changePayYnMemo

                let filterCallAsDetail = param.callAsDetail.filter(f => parseInt(f.asDetailId) === parseInt(vAsDetailId))[0];
                this.payYnCd = filterCallAsDetail.payYn  // 유/무상 코드

                // 유/무상 : AS_DETAIL
                let changePayYnObj = param.getCatDataByParent.filter(x => x.topKey === 'ChangePayYn'
                    && x.catKey === this.payYnCd)
                this.payYnNm = changePayYnObj[0].catNm || '' // 유/무상 명

                /*************************************************************************/
                /***************************  유무상 정보 종료 ***************************/
                /*************************************************************************/


                // 접수/처리유형 변경사유
                this.asClassNm = filterCallAsDetail.asClassNm || '' //접수
                this.changeAsClassCd = param.callAsProcessSel1List[index].changeAsClassCd || '' //변경사유 코드
                this.changeAsClassCdInit = this.changeAsClassCd  // 이거는 왜 넣은거지..?
                this.changeAsClassMemo = param.callAsProcessSel1List[index].changeAsClassMemo || '' //변경사유 메모
            }

            // 장애내역
            this.tableTroubleData = param.callAsCat
                .filter(x=>x.asDetailId==vAsDetailId)
                .map(y => { 
                    let arrCat = y.asCatFullNm.split('>');
                    if(arrCat){
                        if(arrCat.length >= 2){
                            y.breakGb = arrCat[1] ;
                        }
                    }
                    y.breakHst = y.asCatNm;
                    y.breakDtl = y.description;
                    return y;
                });

            // 고장원인
            this.tableFailureCause = param.callAsFailureCause
                                          .filter(x=>x.asDetailId==vAsDetailId && x.asProcessId==vAsProcessId)
                                          .map(y => {
                                            y.ioFlag = 'U' ; // 입력(I),수정(U)
                                            return y
                                          }) || []
            this.tableFailureCauseList = param.callAsFailureCause

            // 수리내역
            this.tableAsRepair = param.callAsRepair
                                    .filter(x=>x.asDetailId==vAsDetailId && x.asProcessId==vAsProcessId)
                                    .map(y=>{
                                        // 무상이면 기술료 0
                                        if(this.payYn !== 'Y') {
                                          y.tmpAsRepairAmt = '0';
                                        }else {
                                          y.tmpAsRepairAmt = y.asRepairAmt;
                                        }
                                        y.ioFlag = 'U' ; // 입력(I),수정(U)
                                        return y;
                                    }) || [] ;
            this.tableAsRepairList = param.callAsRepair

            // 사용/회수자재
            this.tableAsRepairItem = param.callAsRepairItem
                                          .filter(x=>x.asDetailId==vAsDetailId && x.asProcessId==vAsProcessId)
                                          .map(y => {
                                            y.ioFlag = 'U' ; // 입력(I),수정(U)
                                            return y;
                                          }) || []

            this.tableAsRepairItemList = param.callAsRepairItem

            // 접수/처리유형에서 처리가 제품교환인 경우
            const isExchange = this.changeAsClassCd === 'Exchange' ? true : false


            let vChkCallAsProcessMstSelList = false
            if(param.callAsProcessMstSelList && param.callAsProcessMstSelList.length>0){
              vChkCallAsProcessMstSelList = true
            }

            // 교환모델
            if(vChkCallAsProcessMstSelList){
              // 교환모델 callAsProcessMstSelList -> callAsProcessSel1List (MstSelList 에서 2번째 부터 모델을 못불러옴. index 가 안맞음..그래서 이걸로 변경..)
              this.tableChangeModel = param.callAsProcessSel1List
                  .filter(x=>x.asDetailId==vAsDetailId && x.asProcessId==vAsProcessId)
                  .map(y => {
                    y.ioFlag = 'U' ; // 입력(I),수정(U)
                    return y;
                  }) || []
              //여기도 위와 같은 상황
              this.tableChangeModelList = param.callAsProcessSel1List
            }

            // 내근, 외근 구분
          this.costType =  param.callAsMstSelList[0].costType

            // 미처리사유
            this.asStatusReal = param.callAsMstSelList[0].asStatus || ''
            this.asStatus = this.asStatusReal
            if(this.asStatus.length > 1 ){
                // 실제 진행상태('Square','Confirm','Complete','Receipt','Return')의 값이 있는 경우 공백처리
                this.asStatus = ''
            }

            // 미처리사유 메모
            this.asStatusMemo = param.callAsMstSelList[0].asStatusMemo || ''
            
            // 특기사항
            this.catDescription = param.callAsMstSelList[0].description || ''

            // 수리비
            this.tableRepair = [
                {
                asRepairUnitFee: param.callAsMstSelList[0].asRepairUnitFee || '',      /** 자재비 */
                //asItemUnitFee: param.callAsMstSelList[0].asItemUnitFee || '',          /** 자재비 */
                asRepairFee: param.callAsMstSelList[0].asRepairFee || '',              /** 기술료 */
                asRepairFeeAmt: param.callAsMstSelList[0].asRepairFeeAmt || '',        /** 청구금액 */
                asRepairFeeAmtReal: param.callAsMstSelList[0].asRepairFeeAmtReal || '' /** 실청구금액 */
            },]

            // 수리비 리스트
            this.tableRepairList = [
              {

                asRepairUnitFee: param.callAsMstSelList[0].asRepairUnitFee || '',      /** 자재비 */
                //asItemUnitFee: param.callAsMstSelList[0].asItemUnitFee || '',          /** 자재비 */
                asRepairFee: param.callAsMstSelList[0].asRepairFee || '',              /** 기술료 */
                asRepairFeeAmt: param.callAsMstSelList[0].asRepairFeeAmt || '',        /** 청구금액 */
                asRepairFeeAmtReal: param.callAsMstSelList[0].asRepairFeeAmtReal || '' /** 실청구금액 */
              },]

            // 현장사진
            this.$store.commit('loading');
            this.$http.post(`/api/mobile/asMng/picture/files/${this.asId}/${vAsProcessId}/${vAsDetailId}`)
            .then(res => {
                this.fieldImgList = res.data || [];
            })
            .catch(e => {
                this.$swal({ type: 'warning', text: `${e.message}` });
            })
            .finally(() => {
                this.$store.commit('finish');
            })



            /** 선택한 모델에 해당하는 처리내역 조회 : ASIS함수(btnAsProcessTab_AsProcessSelect_Click) */

            // this.$store.commit('loading')
            // this.$http.post(_url("/api/asMng/popup/asRead/getAsProcessId"), {
            //     companyId: 'CENTERLINK', //this.$store.state.loginInfo.compCd,
            //     asId: asId,
            //     asProcessId: asProcessId
            // }).then(response => {
            //      console.log('response.data' , response.data)

            // }).finally(() => {
            //     this.$store.commit('finish')
            // });

            const vSqObj = param.callAsMstSelList[0]
            const vAstatus = vSqObj ? vSqObj.asStatus : ''
            // AS미처리리스트 - AS처리내역  : 214
            const auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===214)

            let GrantCancel = false // 취소권한
            if(auth && auth.length > 0){
                GrantCancel = auth[0].grantExtend2 === 'Y' ? true : false   
            }

            // 수정권한
            // AS미처리리스트 - AS처리내역  : 214
            const vAsProcessEditable = this.getAsProcessEditable(214, vAstatus, vRepairId);

            // 모델정보
            const vShowModelInfo = (vAsProcessEditable && "Complete" !== vAstatus) ? true : false
            this.showModelInfo = vShowModelInfo

            // 고장원인
            const vFailureCauseValidateMode = (vAsProcessEditable && ["Default", "Adjust", "Explanation", "Install", "Exchange", "Refund"].includes(this.changeAsClassCd) ) ? true : false
            this.showFailureCause = vFailureCauseValidateMode

            // 수리내역
            const vAsRepairItemEditable = (vAsProcessEditable && ["Default", "Adjust", "Explanation", "Install", "Exchange", "Refund"].includes(this.changeAsClassCd) ) ? true : false
            this.showRepair = vAsRepairItemEditable

            // 사용/회수자재
            const vRepairItemValidateMode = (vAsProcessEditable && this.changeAsClassCd === 'Default') ? true : false
            this.showRepairItem = vRepairItemValidateMode

            // 교환모델
            const vExchangeValidateMode = (vAsProcessEditable && this.changeAsClassCd === 'Exchange') ? true : false
            this.showChangeModel = vExchangeValidateMode


            this.showAsSaveValidate = vAsProcessEditable           /** 진행중 **/
            this.showItemRequestValidate = vAsProcessEditable      /** 자재요청 **/
            this.showAsCompleteValidate = vAsProcessEditable       /** AS완료 **/

            this.changePayYn = !vAsProcessEditable
            this.itemQtyEditable = vAsProcessEditable              /** 사용/회수자재 수량 변경여부 **/
            this.asStatusEditable = !vAsProcessEditable            /** 미처리사유 비고 **/
            this.readCatDescriptionEditable = !vAsProcessEditable  /** 특기사항 */
            //this.changeModelEditable = vAsProcessEditable && vExchangeValidateMode /** as-is에서 교환모델인데 to-be에서는 showChangeModel로 사용함. **/
            this.costRepairEditable = vAsProcessEditable           /** 실청구금액 **/
        },
        onCellClicked(params, rowIdx) {
            /** 모델을 선택한 경우에 해당하는 처리내역을 호출하도록 함.*/
            const idx = params.rowIndex;
            const field = params.colDef.field;
            this.selProcIdx = idx;

            // 로딩속도 개선 : 직접호출시 속도가 늦음. 이미 로딩된 캐싱을 이용해서 2번 방법 사용.
            // 1. 직접호출
            //this.$emit("loadTab", {"tabNm":"2", "index": idx, "asDetailId": params.data.asDetailId, "asProcessId": params.data.asProcessId })

            // 2. 캐싱 사용
            this.tabCacheLoadData.asDetailId = params.data.asDetailId;
            this.tabCacheLoadData.asProcessId = params.data.asProcessId;

            this.changeProcsHstInfo(this.tabCacheLoadData, idx);
            this.gridApi.redrawRows({ rowNodes: params });

            if(field === 'modelNm') {
              this.openModelSpec(params.data);
            }
        },
        onPayYnChange(value){
            /** 유/무상 > 처리 */
            //console.log('onPayYnChange start====', value)
            /** 변경사유select 재로딩처리 */
            const vPayYnIdx = this.payYnList.findIndex(x=>x.key === value)
            const vParentId = this.payYnIdList[vPayYnIdx].key || 0

            this.changeAsRepairAmt(); // 유무상에 따른 기술료 0원 표기
            this.payYnChangeAmt(); //유무상 변경시 금액 차감

            this.getCombo({flag: '', parentId: vParentId})
        },
        changeAsRepairAmt(){
          // 수리내역 등록된 경우 계산 활성화
          if(this.tableAsRepair[0] !== undefined){
            let newData = this.tableAsRepair[0];
            if(this.payYn === 'Y'){
              newData.tmpAsRepairAmt = 0;
              newData.tmpAsRepairAmt = newData.asRepairAmt;
            } else {
              newData.tmpAsRepairAmt = 0;
            }
            this.$set(this.tableAsRepair, 0, newData);
          }
        },
        onChangeAsClassCdChange(value){
          //자재사용수리
          if(["Default"].includes(value)){
            this.showFailureCause = true;   //고장원인
            this.showRepair = true;         //수리내역
            this.showRepairItem = true;     //사용/회수자재
            this.showChangeModel = false;   //교환모델
          } else if(["Adjust", "Explanation", "Install", "Refund"].includes(value)){
            // 조정완료, 설명완료, 제품설치, 환불완료
            this.showFailureCause = true;   //고장원인
            this.showRepair = true;         //수리내역
            this.showRepairItem = false;    //사용/회수자재
            this.showChangeModel = false;   //교환모델
          } else if(["Exchange"].includes(value)){
            // 제품교환
            this.showFailureCause = true;   //고장원인
            this.showRepair = true;         //수리내역
            this.showRepairItem = false;    //사용/회수자재
            this.showChangeModel = true;    //교환모델
          } else {
            this.showFailureCause = false;  //고장원인
            this.showRepair = false;        //수리내역
            this.showRepairItem = false;    //사용/회수자재
            this.showChangeModel = false;   //교환모델
          }

          if(!["Exchange"].includes(value)){
            if(this.tableChangeModel[0] !== undefined){
              /** 교환모델 삭제 **/
              const newValue = value.newValue;
              const rowIndex = value.rowIndex;
              const newData = this.tableChangeModel[0];
              newData.changeModelId = null
              newData.changeModelNm = ''
              newData.changeSerialNo = ''
              newData.changeProdDt = ''
              this.$set(this.tableChangeModel, 0, newData);
            }
          }

          /** 고장원인 삭제 **/
          if(!this.showFailureCause){
            // 삭제ITEM의 상세키값 저장(기존에 등록 된 자료만 삭제 list에 보관)
            this.tableFailureCause.filter(f => f.ioFlag === 'U').map(x => {
              this.tableFailureCauseDel.push(x);
            })
            this.tableFailureCause.splice(0, this.tableFailureCause.length) // 고장원인 삭제
          }

          /** 수리내역 삭제 **/
          if(!this.showRepair){
            // 삭제ITEM의 상세키값 저장(기존에 등록 된 자료만 삭제 list에 보관)
            this.tableAsRepair.filter(f => f.ioFlag === 'U').map(x => {
              this.tableAsRepairDel.push(x);
            })
            this.tableAsRepair.splice(0, this.tableAsRepair.length) // 사용/회수자재 삭제
          }

          /** 사용/회수자재 삭제 **/
          if(!this.showRepairItem){
            // 삭제ITEM의 상세키값 저장(기존에 등록 된 자료만 삭제 list에 보관)
            this.tableAsRepairItem.filter(f => f.ioFlag === 'U').map(x => {
              this.tableAsRepairItemDel.push(x);
            })
            this.tableAsRepairItem.splice(0, this.tableAsRepairItem.length) // 사용/회수자재 삭제
          }
        },
        goPrint(){
            this.$modal.open({
              width: 1200,
              component: ProcsHstPrint,
              parent: this,
              props: {asId: this.asId}
            });
        },
        async getOutItemCount(){
          let vm = this;
          const vCheckform = this.tableAsRepairItemList.map(x => {
            x.asAgentId = this.$store.state.loginInfo.asAgentId;
            return x;
          });
          this.$store.commit('loading');
          this.$http.post(_url("/api/agent/asCall/getOutItemCount"), vCheckform)
              .then(response => {
                if(response.data !== "success"){
                  this.outItemValue = false;
                  this.$swal({ type: 'warning', text: response.data });
                  return false;
                } else {
                  // AS완료 처리 시작
                  this.asProcBefore().then(async () => {
                    if(this.outItemValue) {
                      await this.asProc();
                    }
                  });
                }
              }).catch((e) => {
            this.$swal({ type: 'warning', text: '자재가 출고되지 않았습니다.' });
          }).finally(() => {
            this.$store.commit('finish');
          });
        },
        // 진행중
        asProcessSave(type) {

            let vm = this;
            let vCallAsDescription = null ;
            let vAsStatus = null;
            console.log("type=======> ",type)
            if(this.asStatus === ''  &&  type === 'SAVE'  ){
              this.$swal({ type: 'warning', text: '미처리사유를 선택해 주십시오.' });
              return false;
            }

            if(type === 'REQ'){
              vAsStatus = 'J'
            } else {
              vAsStatus = vm.asStatus === '' ? 'Receipt' : vm.asStatus
            }

            vCallAsDescription = {
              asId : vm.asId,
              description : vm.catDescription,
              asStatusMemo : vm.asStatusMemo,
              asStatus : vAsStatus
            }

            const vCallAsProcess = {
              asId : vm.asId,
              asDetailId : vm.tabCacheLoadData.asDetailId,
              asProcessId : vm.tabCacheLoadData.asProcessId,
              maker : vm.tableModelInfo[0].maker,
              modelGroup : vm.tableModelInfo[0].modelGroup !== undefined ? vm.tableModelInfo[0].modelGroup : '',
              modelId : vm.tableModelInfo[0].modelId,
              serialNo : vm.tableModelInfo[0].serialNo !== undefined ? vm.tableModelInfo[0].serialNo : '',
              purchaseDt : this.getProcessData(vm.tableModelInfo[0].purchaseDt),
              prodDt : this.getProcessData(vm.tableModelInfo[0].prodDt),
              guaranteeDt : vm.tableChangeModel[0] === undefined ? '1900-01-01' : (vm.tableChangeModel[0].guaranteeDt !== null ? vm.tableChangeModel[0].guaranteeDt : '1900-01-01'),
              changeModelId : vm.tableChangeModel[0] === undefined ? 0 : (vm.tableChangeModel[0].changeModelId !== null ? vm.tableChangeModel[0].changeModelId : 0),
              changeSerialNo : vm.tableChangeModel[0] === undefined ? '' : (vm.tableChangeModel[0].changeSerialNo !== null ? vm.tableChangeModel[0].changeSerialNo : ''),
              changeProdDt : vm.tableChangeModel[0] === undefined ? '1900-01-01' : this.getProcessData(vm.tableChangeModel[0].changeProdDt),
              changeGuaranteeDt : vm.tableChangeModel[0] === undefined ? '1900-01-01' : (vm.tableChangeModel[0].changeGuaranteeDt !== null ? vm.tableChangeModel[0].changeGuaranteeDt : '1900-01-01'),
              repairAsAgentId : vm.tableChangeModel[0] === undefined ? 0 : vm.tableChangeModel[0].repairAsAgentId,
              repairId : vm.tableChangeModel[0] === undefined ? 0 : vm.tableChangeModel[0].repairId,
              changeAsClassCd : vm.changeAsClassCd,
              changeAsClassMemo : vm.changeAsClassMemo,
              changePayYnCd : vm.changePayYnCd !== "" ? vm.changePayYnCd : vm.payYn,
              changePayYnMemo : vm.changePayYnMemo,
            };

            // 진행중
            const vSaveform ={
              callAsFailureCause : this.tableFailureCause || '',         // 고장원인
              callAsFailureCauseDel : this.tableFailureCauseDel || '',   // 고장원인삭제
              callAsRepair: this.tableAsRepair || '',                    // 수리내역
              callAsRepairDel: this.tableAsRepairDel || '',              // 수리내역삭제
              callAsRepairItem : this.tableAsRepairItem || '',           // 사용/회수자재
              callAsRepairItemDel : this.tableAsRepairItemDel || '',     // 사용/회수자재 삭제
              asId : vm.asId,                                            // asId
              callAsProcess : vCallAsProcess,                            // 기본저장(모델정보)
              callAsDescription : vCallAsDescription,                    // 자재요청 특기, 미처리사유 등 저장
            };

            vm.totalAmt = this.tableRepair[0].asRepairFeeAmtReal

            this.$swal({
              type: 'warning',
              text: `저장하시겠습니까?`,
              showCancelButton: true,
              confirmButtonText: '예',
              cancelButtonText: '아니오',
            }).then((result) => {
              if (result.value) {
                this.$store.commit('loading');
                this.$http.post(_url("/api/agent/asCall/saveAs"), vSaveform)
                    .then(response => {

                      if(type !== 'REQ' && type !== 'PROC'){
                        this.$swal({ type: 'success', text: '저장되었습니다.' });
                      }

                      /** 저장 후 재조회 시작 **/
                      let vParam = {
                        asDetailId : vCallAsProcess.asDetailId,
                        asProcessId : vCallAsProcess.asProcessId
                      }
                      vm.$parent.$parent.goOpen('INIT', vParam).then(async () => {
                        if(type === 'REQ'){
                          this.asReq();
                        } else if (type === 'PROC'){
                          // 사용회수자재를 입력했을 경우
                          if (this.tableAsRepairItemList.length > 0) {
                            // 자재수량 체크
                            await this.getOutItemCount();
                          } else {
                            await this.asProcBefore().then(async ()  => {
                              await this.asProc();
                            });
                          }
                        } else if (type === 'MODEL'){

                          if(this.data && this.data.length >= this.selProcIdx ){
                            this.tabCacheLoadData.asDetailId = this.data[this.selProcIdx].asDetailId;
                            this.tabCacheLoadData.asProcessId = this.data[this.selProcIdx].asProcessId;
                            this.changeProcsHstInfo(this.tabCacheLoadData, this.selProcIdx);
                          }
                        }
                      })
                      /** 저장 후 재조회 종료 **/

                    }).catch((e) => {
                      this.$swal({ type: 'warning', text: '저장에 실패 했습니다.' });
                    }).finally(() => {
                      this.$store.commit('finish');

                });
              }
            });
        },
        // AS자재요청
        asReq(){
          let vm = this;
          let componentNm;

          if(vm.changeAsClassCd === 'Default'){
            if(vm.tableAsRepairItem.length <= 0){
              this.$swal({ type: 'warning', text: '먼저 사용/회수 자재를 추가해주세요.' });
              return false;
            }
            componentNm = RequestMateEnterModal
          } else {
            // 기타
            componentNm = ReqMateEnterModal
          }

          vm.$modal.open({
            component: componentNm,
            parent: this,
            width: 700,
            props: {
              data: {
                asId : vm.asId
              }
            },
            events: {
              close(object) {
                // rowNode.setDataValue('recallItemCd', object.itemCd);
                // rowNode.setDataValue('recallItemNm', object.itemNm);
                // that.data[that.rowId].recallItemCd = object.itemCd;
                // that.data[that.rowId].recallItemNm = object.itemNm;
              }
            }
          });
        },
        // AS완료처리
        async asProcBefore() {
          let vm = this;

          const vAsProc = {
            asId : vm.asId,
            description : vm.catDescription,
            asRepairFeeAmtReal : vm.totalAmt //vm.tableRepair[0].asRepairFeeAmtReal
          }

          const vSaveform ={
            callAsProc : vAsProc // AS완료 버튼 클릭
          };

          this.$store.commit('loading');
          return await this.$http.post(_url("/api/agent/asCall/procAsBefore"), vSaveform)
              .then( response => {
              }).catch((e) => {
            this.$swal({ type: 'warning', text: 'AS처리에 실패 했습니다.' });
          }).finally(() => {
            this.$store.commit('finish');
          });
        },
        // AS완료 후처리
        async asProc() {

          let vm = this;

          // validation 체크
          for(let i = 0; i < this.tableModelInfoList.length; i ++){

            let vAsDetailId = this.tableModelInfoList[i].asDetailId;
            let vAsProcessId = this.tableModelInfoList[i].asProcessId;

            // ASIS에서 아래와 같이 flag로 사용함.. (왜 이렇게 하지..?)
            const flag1 = ["Default", "Adjust", "Explanation", "Install", "Exchange", "Refund"].includes(this.tableModelInfoList[i].changeAsClassCd);
            const flag2 = ["Default", "Adjust", "Explanation", "Install", "Exchange", "Refund"].includes(this.tableModelInfoList[i].changeAsClassCd);
            const flag3 = ["Exchange"].includes(this.tableModelInfoList[i].changeAsClassCd);
            const flag4 = ["Default", "Adjust", "Explanation", "Install", "Exchange", "Refund"].includes(this.tableModelInfoList[i].changeAsClassCd);
            const flag5 = ["Default", "Adjust", "Explanation", "Install", "Exchange", "Refund"].includes(this.tableModelInfoList[i].changeAsClassCd);
            const flag6 = ["Default"].includes(this.tableModelInfoList[i].changeAsClassCd);
            // ASIS에서 아래와 같이 flag로 사용함.. (왜 이렇게 하지..?)

            if(this.tableModelInfoList[i].changeAsClassCd.length <= 0 ){
              this.$store.commit('finish')
              this.$swal({ type: 'warning', text: i + 1 + '번 제품의 처리유형을 선택해주세요.' });
              return false;
            }

            if (flag1) {
              if(this.tableModelInfoList[i].modelGroupNm.length <= 0 ){
                this.$swal({ type: 'warning', text: i + 1 + '번 제품의 제품군이 비어있습니다.' });
                return false;
              }
              if(this.tableModelInfoList[i].modelNm.length <= 0 ){
                this.$swal({ type: 'warning', text: i + 1 + '번 제품의 모델명이 비어있습니다.' });
                return false;
              }
              if(this.tableModelInfoList[i].serialNo.length <= 0 ){
                this.$swal({ type: 'warning', text: i + 1 + '번 제품의 제조번호가 비어있습니다.' });
                return false;
              }
              if(this.tableModelInfoList[i].prodDt === null ){
                this.$swal({ type: 'warning', text: i + 1 + '번 제품의 제조년월이 비어있습니다.' });
                return false;
              }
              if(this.tableModelInfoList[i].purchaseDt.length <= 0 ){
                this.$swal({ type: 'warning', text: i + 1 + '번 제품의 구입년월이 부정확합니다.' });
                return false;
              }
              if(this.tableModelInfoList[i].payYn.length <= 0 && this.tableModelInfoList[i].changePayYnCd.length <= 0){
                this.$swal({ type: 'warning', text: i + 1 + '번 제품의 유/무상 변경사유가 선택되지 않았습니다.' });
              }
            }

            if(this.tableModelInfoList[i].changeAsClassCd == "Cancel" && this.tableModelInfoList[i].changeAsClassMemo.length <= 0){
              this.$swal({ type: 'warning', text: i + 1 + '번 제품의 처리유형 변경사유가 입력되지 않습니다.' });
              return false;
            }

            if (flag4){
              if(this.tableFailureCauseList.filter(f => f.asDetailId == vAsDetailId && f.asProcessId == vAsProcessId).length <= 0){
                this.$swal({ type: 'warning', text: i + 1 + '번 제품에 고장원인이 등록되지 않았습니다.' });
                return false;
              }
            }

            if (flag5){
              if(this.tableAsRepairList.filter(f => f.asDetailId == vAsDetailId && f.asProcessId == vAsProcessId) <= 0){
                this.$swal({ type: 'warning', text: i + 1 + '번 제품에 수리내역이 등록되지 않았습니다.' });
                return false;
              }
            }

            if (flag6){
              if(this.tableAsRepairItemList.filter(f => f.asDetailId == vAsDetailId && f.asProcessId == vAsProcessId) <= 0){
                this.$swal({ type: 'warning', text: i + 1 + '번 제품에 사용/회수자재가 등록되지 않았습니다.' });
                return false;
              }

              for(let j = 0; j < this.tableAsRepairItemList.length; j ++){
                if(this.tableAsRepairItemList[j].itemQty <= 0 ){
                  this.$swal({ type: 'warning', text: i + 1 + '번 제품에 ' + this.tableAsRepairItemList[j].itemNm +  '의 수량은 1이상이어야 합니다.' });
                  return false;
                }
              }
            }

            if (flag3){
              if(!this.tableChangeModelList[i].changeModelId){
                this.$swal({ type: 'warning', text: i + 1 + '번 제품의 교환모델이 선택되지 않았습니다.' });
                return false;
              }
              if(!this.tableChangeModelList[i].changeSerialNo){
                this.$swal({ type: 'warning', text: i + 1 + '번 제품의 교환모델 제조번호가 비어있습니다.' });
                return false;
              }
              if(!this.tableChangeModelList[i].changeProdDt){
                this.$swal({ type: 'warning', text: i + 1 + '번 제품의 교환모델 제조년월이 부정확합니다.' });
                return false;
              }
            }
          }

          const vAsProc = {
            asId : vm.asId,
            description : vm.catDescription,
            asRepairFeeAmtReal : vm.totalAmt //vm.tableRepair[0].asRepairFeeAmtReal
          }

          const vSaveform = {
            asId : vm.asId,
            smsYn: vm.smsYn,
            callAsProc : vAsProc // AS완료 버튼 클릭
          };

          this.$store.commit('loading');
          this.$http.post(_url("/api/agent/asCall/procAs"), vSaveform)
              .then(response => {
                this.$swal({ type: 'success', text: '처리되었습니다.' });

                /** 저장 후 재조회 시작 **/
                let componentNm;
                let vParam = {
                  asDetailId : 1,
                  asProcessId : 1
                }
                vm.$parent.$parent.goOpen('INIT', vParam)
                /** 저장 후 재조회 종료 **/
              }).catch((e) => {
            this.$swal({ type: 'warning', text: 'AS처리에 실패 했습니다.' });
          }).finally(() => {
            this.$store.commit('finish');
          });
        },

        searchModel(mode){
          /** 모델선택 */
          let vm = this;
          this.$modal.open({
            width: 800,
            component: ModelSelectModal,
            parent: this,
            props: {
              data: {},
            },
            events: {
              close(param) {

                if(mode === 'modelInfo'){
                  const rowNode = vm.modelGridOptions.api.getRowNode(0);
                  rowNode.setDataValue('makerNm', param.data.makerNm)
                  rowNode.setDataValue('modelGroupNm', param.data.modelGroupNm)
                  rowNode.setDataValue('modelNm', param.data.modelNm)

                  vm.tableModelInfo[0].maker = param.data.maker; /** 제조사 */
                  vm.tableModelInfo[0].makerNm = param.data.makerNm; /** 제조사명 */
                  vm.tableModelInfo[0].modelGroup = param.data.modelGroup /** 모델그룹 */
                  vm.tableModelInfo[0].modelGroupNm = param.data.modelGroupNm /** 모델그룹명 */
                  vm.tableModelInfo[0].standardModelNm = param.data.standardModelNm /** 모델ID */
                  vm.tableModelInfo[0].modelNm = param.data.modelNm /** 모델명 */
                  vm.tableModelInfo[0].modelId = param.data.modelId /** 모델ID */
                } else if(mode === 'changeModel'){
                  const rowNode = vm.modelItemGridOptions.api.getRowNode(0);
                  rowNode.setDataValue('changeModelNm', param.data.modelNm)

                  vm.tableChangeModel[0].changeModelId = param.data.modelId;      /** 모델id */
                  vm.tableChangeModel[0].changeModelNm = param.data.modelNm;      /** 모델명 */
                }
              },
            }
          });
        },

        // 고장원인 추가
        failureCauseModal(){
            const vm = this
            const vSelModelObj ={}

            this.$modal.open({
                component: FailureCauseSelect,
                parent: this,
                props: {
                    data: {
                        selModelObj: vSelModelObj
                    },
                },
                events: {
                    close(param) {
                        if(param.data){
                            vm.tableFailureCause = vm.tableFailureCause ? vm.tableFailureCause : []
                            param.data.forEach(x => {
                                const chkObj = vm.tableFailureCause.filter(y=>y.asFailureCauseCatId===parseInt(x.asCatId))
                                if(chkObj && chkObj.length>0 ){
                                    // skip
                                } else {
                                    const tmp = {
                                        chk: 'Y',
                                        asId: vm.asId,
                                        asDetailId : vm.tabCacheLoadData.asDetailId,
                                        asProcessId : vm.tabCacheLoadData.asProcessId,
                                        asCatId: x.asCatId,
                                        asFailureCauseCat1: x.gbCd,
                                        asFailureCauseCatNm: x.gbNm,
                                        asFailureCauseCatId : x.asCatId,
                                        asFailureCauseId : 0,
                                        description: '',
                                        ioFlag: 'I'
                                    }
                                    vm.tableFailureCause.push(tmp)
                                }
                            })

                        }
                    },
                }
            });
        },
        // 고장원인 삭제
        deleteFailureCauseRow(){
            const vm = this;
            let vSrcObj = this.tableFailureCause
            let chkedObj = vSrcObj.filter(x=>x.chk==='Y')

            if(!vSrcObj || chkedObj.length === 0){
                this.$swal({
                type: 'warning',
                text: '선택된 행이 없습니다.'
                });

                return false
            }
            // 삭제ITEM의 상세키값 저장(기존에 등록 된 자료만 삭제 list에 보관)
            chkedObj.filter(f => f.ioFlag === 'U')
                    .map(x=>{
                      if(x.asFailureCauseCatId != null){
                        vm.tableFailureCauseDel.push(x);
                      }
                      return x;
            });
            vm.tableFailureCause = vSrcObj.filter(x=>x.chk!='Y')
        },
        // 수리내역 추가
        repairCatModal(){
          const vm = this
          const vModelNm =this.tableModelInfo[0].modelNm
          const vModelGroup = this.tableModelInfo[0].modelGroup

          if(this.tableAsRepair.length > 0){
            this.$swal({ type: 'warning', text: '수리내역은 1건 이상 등록할 수 없습니다.'});
            return false;
          }

          this.$modal.open({
            component: RepairCatSelect,
            parent: this,
            props: {
              data: {
                modelNm: vModelNm,
                itemGroup: vModelGroup
              },
            },
            events: {
              close(param) {
                if(param.length > 1){
                  vm.$swal({ type: 'warning', text: '수리내역은 1건 이상 등록할 수 없습니다.'});
                  return false;
                }
                if(param){
                  vm.tableAsRepair = vm.tableAsRepair ? vm.tableAsRepair : []
                  param.forEach(x => {
                    const chkObj = vm.tableAsRepair.filter(y=>y.asRepairCatId===parseInt(x.repairCatId))
                    if(chkObj && chkObj.length>0 ){
                      // skip
                    } else {
                      const tmp = {
                        chk: 'Y',
                        asId: vm.asId,
                        asDetailId : vm.tabCacheLoadData.asDetailId,
                        asProcessId : vm.tabCacheLoadData.asProcessId,
                        asRepairCatId: x.repairCatId,
                        asRepairCat1: x.catNm3,          // 증상구분
                        asRepairCat2: x.catNm4,          // 고장증상
                        asRepairCat3: x.catNm5,          // 고장부위
                        asRepairAmt: vm.costType === 'IN' ? x.repairFee1 : x.repairFee2,       // 기술료 (내근, 외근 값 구분)
                        tmpAsRepairAmt: vm.costType === 'IN' ? x.repairFee1 : x.repairFee2,    // 기술료(임시 보관 위함) (내근, 외근 값 구분)
                        asRepairId: 0,
                        description: '',
                        ioFlag: 'I'
                      }
                      vm.tableAsRepair.push(tmp)
                    }
                  })

                }
                vm.repairFeeAmtCompute();
              },
            }
          });
        },
        // 수리내역 삭제
        deleteRepairCatRow(){
          const vm = this;
          let vSrcObj = this.tableAsRepair
          let chkedObj = vSrcObj.filter(x=>x.chk==='Y')

          if(!vSrcObj || chkedObj.length === 0){
            this.$swal({
              type: 'warning',
              text: '선택된 행이 없습니다.'
            });
            return false
          }

          // 삭제ITEM의 상세키값 저장(기존에 등록 된 자료만 삭제 list에 보관)
          chkedObj.filter(f => f.ioFlag === 'U')
                  .map(x=>{
                      if(x.asRepairCatId != null){
                        vm.tableAsRepairDel.push(x);
                      }
                      return x;
          });
          this.tableAsRepair = vSrcObj.filter(x=>x.chk!='Y')
          this.repairFeeAmtCompute();
        },
        recallMateSelectModal(){
          const that = this;

          // const rowNode = this.mainGridApi.getRowNode(this.mainRowId);
          const rowNode = this.repairItemGridOptions.api.getRowNode(this.mainRowIndex);

          this.$modal.open({
            component: RecallMateSelectModal,
            parent: this,
            width: 700,
            props: {
              data: {
                modelNm : that.tableModelInfo[0].modelNm,
                ModelGroup : that.tableModelInfo[0].modelGroup
              }
            },
            events: {
              close(object) {
                console.log('object     ', object);
                //
                // rowNode.setDataValue('recallItemCd', object.itemCd);
                // rowNode.setDataValue('recallItemNm', object.itemNm);
                // that.mainData[that.mainRowIndex].recallItemCd = object.itemCd;
                // that.mainData[that.mainRowIndex].recallItemNm = object.itemNm;
              }
            }
          });
        },

        //사용/회수자재 수정
        // recallMateSelectModal(){
        //   const vm = this
        //   const vModelNm =this.tableModelInfo[0].modelNm
        //   const vModelGroup =this.tableModelInfo[0].modelGroup
        //
        //   this.$modal.open({
        //     component: RecallMateSelectModal,
        //     parent: this,
        //     props: {
        //       data: {
        //         modelNm: vModelNm,
        //         modelGroup: vModelGroup
        //       },
        //     },
        //     events: {
        //       close(param) {
        //         if(param){
        //           param.map(x => {
        //             if(x.goodQty === 0 || x.goodQty === '' || x.goodQty === null ){
        //               vm.$swal({type: 'warning',text: '보유재고 없습니다. 자재를 요청하세요.'});
        //             }
        //           })
        //           vm.tableAsRepairItem = vm.tableAsRepairItem ? vm.tableAsRepairItem : []
        //
        //           param.forEach(x => {
        //             const chkObj = vm.tableAsRepairItem.filter(y=>y.itemId===x.itemId)
        //             if(chkObj && chkObj.length>0 ){
        //               // skip
        //             } else {
        //               const tmp = {
        //                 chk: 'Y',
        //                 asId: vm.asId,
        //                 asDetailId : vm.tabCacheLoadData.asDetailId,
        //                 asProcessId : vm.tabCacheLoadData.asProcessId,
        //                 itemId: x.itemId,
        //                 itemCd: x.itemCd,         // 사용품번
        //                 itemNm: x.itemNm,         // 사용품번
        //                 itemQty: 1,               // 수량
        //                 recallItemId : x.itemId,  //
        //                 recallItemCd : x.itemCd,  // 회수품번
        //                 recallItemNm : x.itemNm,  // 회수품명
        //                 recallItemQty : 1,        // 회수수량
        //                 unitPrice1: x.unitPrice1, //
        //                 unitPrice2: x.unitPrice2, //
        //                 unitPrice3: x.unitPrice3, // 단가
        //                 itemAmt1: x.unitPrice1, //
        //                 itemAmt2: x.unitPrice2, //
        //                 itemAmt3: x.unitPrice3, //
        //                 asRepairItemId: 0,
        //                 ioFlag: 'I'
        //               }
        //               vm.tableAsRepairItem.push(tmp)
        //             }
        //           })
        //
        //         }
        //         vm.repairFeeAmtCompute();
        //       },
        //     }
        //   });
        // },
        // 사용/회수자재 추가
        useMateSelectModal(){
          const vm = this
          const vModelNm =this.tableModelInfo[0].modelNm
          const vModelGroup =this.tableModelInfo[0].modelGroup

          this.$modal.open({
            component: UseMateSelectModal,
            parent: this,
            props: {
              data: {
                modelNm: vModelNm,
                modelGroup: vModelGroup
              },
            },
            events: {
              close(param) {
                if(param){
                  param.map(x => {
                    if(x.goodQty === 0 || x.goodQty === '' || x.goodQty === null ){
                      vm.$swal({type: 'warning',text: '보유재고 없습니다. 자재를 요청하세요.'});
                    }
                  })
                  vm.tableAsRepairItem = vm.tableAsRepairItem ? vm.tableAsRepairItem : []

                  param.forEach(x => {
                    const chkObj = vm.tableAsRepairItem.filter(y=>y.itemId===x.itemId)
                    if(chkObj && chkObj.length>0 ){
                      // skip
                    } else {
                      const tmp = {
                        chk: 'Y',
                        asId: vm.asId,
                        asDetailId : vm.tabCacheLoadData.asDetailId,
                        asProcessId : vm.tabCacheLoadData.asProcessId,
                        itemId: x.itemId,
                        itemCd: x.itemCd,         // 사용품번
                        itemNm: x.itemNm,         // 사용품번
                        itemQty: 1,               // 수량
                        recallItemId : x.itemId,  //
                        recallItemCd : x.itemCd,  // 회수품번
                        recallItemNm : x.itemNm,  // 회수품명
                        recallItemQty : 1,        // 회수수량
                        unitPrice1: x.unitPrice1, //
                        unitPrice2: x.unitPrice2, //
                        unitPrice3: x.unitPrice3, // 단가
                        itemAmt1: x.unitPrice1, //
                        itemAmt2: x.unitPrice2, //
                        itemAmt3: x.unitPrice3, //
                        asRepairItemId: 0,
                        ioFlag: 'I'
                      }
                      vm.tableAsRepairItem.push(tmp)
                    }
                  })

                }
                vm.repairFeeAmtCompute();
              },
            }
          });
        },
        // 사용/회수자재 삭제
        deleteUseMateRow(){
          const vm = this;
          let vSrcObj = this.tableAsRepairItem
          let chkedObj = vSrcObj.filter(x=>x.chk==='Y')

          if(!vSrcObj || chkedObj.length === 0){
            this.$swal({
              type: 'warning',
              text: '선택된 행이 없습니다.'
            });
            return false
          }
          // 삭제ITEM의 상세키값 저장(기존에 등록 된 자료만 삭제 list에 보관)
          chkedObj.filter(f => f.ioFlag === 'U')
                  .map(x=>{
                      if(x.itemId != null){
                        vm.tableAsRepairItemDel.push(x);
                      }
            return x;
          });
          this.tableAsRepairItem = vSrcObj.filter(x=>x.chk!='Y')
          this.repairFeeAmtCompute();
        },

        // 교환모델 삭제
        deleteChangeModelRow(){

          const vm = this;
          const rowNode = vm.modelItemGridOptions.api.getRowNode(0);
          rowNode.setDataValue('changeModelNm', '')
          rowNode.setDataValue('changeSerialNo', '')
          rowNode.setDataValue('changeProdDt', '')

          this.tableChangeModel[0].changeModelId = null;
          this.tableChangeModel[0].changeModelNm = '';
          this.tableChangeModel[0].changeSerialNo = '';
          this.tableChangeModel[0].changeProdDt = '';
        },

        viewImg(row, column, event){
            this.openFieldImgModel(row);
        },
        openFieldImgModel(param) {
            /** 현장사진 팝업 */

            let vm = this;
            this.$modal.open({
                width: 950,
                component: FieldImgModal,
                parent: this,
                props: {
                    imgobj: param || []
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
        getAsProcessEditable(programId, vAstatus, vRepairId){
          const auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===programId)
          // 고장원인
          let GrantUpdateAll = false // 전체수정권한
          let GrantUpdate = false
          let AS_STATUS = false
          let REPAIR_ID = false

          if(auth && auth.length > 0){
            GrantUpdateAll = auth[0].grantExtend1 === 'Y' ? true : false
            GrantUpdate = auth[0].grantUpdate === 'Y' ? true : false
            REPAIR_ID = parseInt(this.$store.state.loginInfo.id) === parseInt(vRepairId) ? true : false
            AS_STATUS = !["Complete", "Confirm", "Square", "Return", ""].includes(vAstatus)
          }
          return GrantUpdateAll && GrantUpdate && AS_STATUS && REPAIR_ID
        },
        repairFeeAmtCompute(){

          const vm = this;

          let editRepairFee = 0;          // 기술료 추가금액
          let editDelRepairFee = 0;       // 기술료 삭제금액
          let editRepairUnitFee = 0;      // 자재비 추가금액
          let editDelRepairUnitFee = 0;   // 자재비 삭제금액

          let vAsDetailId = this.tabCacheLoadData.asProcessId
          let vAsProcessId = this.tabCacheLoadData.asProcessId

          const asIsTotalData = this.tableRepairList[0];                      // 컨트롤 전 합계금액
          const newData = this.tableRepair[0]                                 // 컨트롤 후 합계금액

          let totalAsRepairFee = parseInt(asIsTotalData.asRepairFee);         // 합계 기술료
          let totalAsRepairUnitFee = parseInt(asIsTotalData.asRepairUnitFee); // 합계 사용/회수자재
          let totalAsRepairFeeAmt = parseInt(asIsTotalData.asRepairFeeAmt)    // 합계 청구금액

          /** 유/무상 처리 '유상'인 경우  **/
          if(vm.payYn === "Y"){

            /** 자재비 추가 금액 **/
            editRepairUnitFee = this.tableAsRepairItem.filter(f => f.ioFlag !== 'U').reduce((accumulator, currentValue) => {
              let sum = accumulator;
              for (let key in currentValue) {
                if(key.includes('itemAmt3')){
                  sum += parseInt(currentValue[key]);
                }
              }
              return sum;
            }, 0);

            /** 자재비 삭제 금액 **/
            editDelRepairUnitFee = this.tableAsRepairItemDel.reduce((accumulator, currentValue) => {
              let sum = accumulator;
              for (let key in currentValue) {
                if(key.includes('itemAmt3')){
                  sum += parseInt(currentValue[key]);
                }
              }
              return sum;
            }, 0);

            /** 기술료 추가 금액 **/
            editRepairFee = this.tableAsRepair.filter(f => f.ioFlag !== 'U').reduce((accumulator, currentValue) => {
              let sum = accumulator;
              for(let key in currentValue){
                if(key.includes('tmpAsRepairAmt')){
                  sum += parseInt(currentValue[key]);
                }
              }
              return sum;
            }, 0);

            /** 기술료 삭제 금액 **/
            editDelRepairFee = this.tableAsRepairDel.reduce((accumulator, currentValue) => {
              let sum = accumulator;
              for(let key in currentValue){
                if(key.includes('tmpAsRepairAmt')){
                  sum += parseInt(currentValue[key]);
                }
              }
              return sum;
            }, 0);

            // 자재비 = 저장된 자재비 금액 - 삭제 자재 금액 - 추가 자재 금액
            newData.asRepairUnitFee = totalAsRepairUnitFee - editDelRepairUnitFee + editRepairUnitFee;

            // 기술료 = 저장된 기술료 - 삭제 기술료 - 추가 기술료
            newData.asRepairFee = totalAsRepairFee - editDelRepairFee + editRepairFee;

            // 청구금액 : 자재비 + 기술료
            newData.asRepairFeeAmt = newData.asRepairUnitFee + newData.asRepairFee

            // 상태가 AS완료 이전은 계산된 값만 표기
            if(this.asStatusReal !== 'Complete'){
              newData.asRepairFeeAmtReal = newData.asRepairUnitFee + newData.asRepairFee  ; /** 실청구금액 : 기술료 + 자재비 **/
            }

            this.$set(this.tableRepair, 0, newData);

          }
          // else {
          //   // 무상인 경우
          //
          //   /** 자재비 금액 **/
          //   editRepairUnitFee = this.tableAsRepairItem.reduce((accumulator, currentValue) => {
          //     let sum = accumulator;
          //     for (let key in currentValue) {
          //       if(key.includes('itemAmt3')){
          //         sum += parseInt(currentValue[key]);
          //       }
          //     }
          //     return sum;
          //   }, 0);
          //
          //   /** 기술료 금액 **/
          //   editRepairFee = this.tableAsRepair.reduce((accumulator, currentValue) => {
          //     let sum = accumulator;
          //     for(let key in currentValue){
          //       if(key.includes('asRepairAmt')){
          //         sum += parseInt(currentValue[key]);
          //       }
          //     }
          //     return sum;
          //   }, 0);
          //
          //   // 자재비 = 저장된 자재비 금액 - 자재비 금액
          //   newData.asRepairUnitFee = totalAsRepairUnitFee - editRepairUnitFee;
          //
          //   // 기술료 = 저장된 기술료 - 기술료
          //   newData.asRepairFee = totalAsRepairFee - editRepairFee;
          //
          //   // 청구금액 : 자재비 + 기술료
          //   newData.asRepairFeeAmt = newData.asRepairUnitFee + newData.asRepairFee
          //
          //   // 상태가 AS완료 이전은 계산된 값만 표기
          //   if(this.asStatusReal !== 'Complete'){
          //     newData.asRepairFeeAmtReal = newData.asRepairUnitFee + newData.asRepairFee  ; /** 실청구금액 : 기술료 + 자재비 **/
          //   }
          //
          //   this.$set(this.tableRepair, 0, newData);
          // }
        },
        payYnChangeAmt(){

          const vm = this;

          let editRepairFee = 0;          // 기술료 추가금액
          let editDelRepairFee = 0;       // 기술료 삭제금액
          let editRepairUnitFee = 0;      // 자재비 추가금액
          let editDelRepairUnitFee = 0;   // 자재비 삭제금액

          let vAsDetailId = this.tabCacheLoadData.asProcessId
          let vAsProcessId = this.tabCacheLoadData.asProcessId

          const asIsTotalData = this.tableRepairList[0];                      // 컨트롤 전 합계금액
          const newData = this.tableRepair[0]                                 // 컨트롤 후 합계금액

          let totalAsRepairFee = parseInt(newData.asRepairFee);         // 합계 기술료
          let totalAsRepairUnitFee = parseInt(newData.asRepairUnitFee); // 합계 사용/회수자재
          let totalAsRepairFeeAmt = parseInt(newData.asRepairFeeAmt)    // 합계 청구금액

          /** 자재비 금액 **/
          editRepairUnitFee = this.tableAsRepairItem.reduce((accumulator, currentValue) => {
            let sum = accumulator;
            for (let key in currentValue) {
              if(key.includes('itemAmt3')){
                sum += parseInt(currentValue[key]);
              }
            }
            return sum;
          }, 0);

          /** 기술료 금액 **/
          editRepairFee = this.tableAsRepair.reduce((accumulator, currentValue) => {
            let sum = accumulator;
            for(let key in currentValue){
              if(key.includes('asRepairAmt')){
                sum += parseInt(currentValue[key]);
              }
            }
            return sum;
          }, 0);


          /** 유/무상 처리 '무상'인 경우  **/
          if(vm.payYn === "N") {

            // 자재비 = 저장된 자재비 금액 - 자재비 금액
            newData.asRepairUnitFee = totalAsRepairUnitFee - editRepairUnitFee;

            // 기술료 = 저장된 기술료 - 기술료
            newData.asRepairFee = totalAsRepairFee - editRepairFee;

            // 청구금액 : 자재비 + 기술료
            newData.asRepairFeeAmt = newData.asRepairUnitFee + newData.asRepairFee
          } else {
            // 유상인 경우

            // 자재비 = 저장된 자재비 금액 - 자재비 금액
            newData.asRepairUnitFee = totalAsRepairUnitFee + editRepairUnitFee;

            // 기술료 = 저장된 기술료 - 기술료
            newData.asRepairFee = totalAsRepairFee + editRepairFee;

            // 청구금액 : 자재비 + 기술료
            newData.asRepairFeeAmt = newData.asRepairUnitFee + newData.asRepairFee

          }


          // 상태가 AS완료 이전은 계산된 값만 표기
          if(this.asStatusReal !== 'Complete'){
            newData.asRepairFeeAmtReal = newData.asRepairUnitFee + newData.asRepairFee  ; /** 실청구금액 : 기술료 + 자재비 **/
          }

          this.$set(this.tableRepair, 0, newData);
        },
        onCellValueChanged(params) {
          if (params.colDef.field === "itemQty") {
            // a 컬럼이 변경되었을 때만 처리
            const newValue = params.newValue;
            const rowIndex = params.rowIndex;
            const newData = this.tableAsRepairItem[rowIndex];
            newData.itemAmt3 = newData.unitPrice3 * newValue         // 청구금액
            newData.recallItemQty = newValue                         // 회수수량의 값을 사용수량 값으로 변경
            this.$set(this.tableAsRepairItem, rowIndex, newData);    // 변경된 데이터를 반영
            this.repairFeeAmtCompute();
          }
        },
        /**
         * 모델 사양 팝업 오픈
         * * 그리드 상 모델 선택시 오픈되어지는 모델 사양
         */
        openModelSpec(param) {

          const vForm = {
            modelGroup: param.modelGroup,
            modelCd : param.modelNm
          };

          this.$modal.open({component: ProductMenu, parent: this, width: 1200, props: {data: vForm}});
        },
        getProcessData(data) {
          if (data === undefined || data === '' || data === null) {
            return '1900-01-01';
          } else {
            const vdata = String(data).replace(/-/g, '');
            return vdata.substring(0,4) + '-' + vdata.substring(4,6) + '-01'
          }
        },
        modelGridCellValueChange(params) {
          if(params.colDef.field === 'serialNo'){
            const inputValue = params.newValue || '';
            const filteredValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
            params.data.value = filteredValue;

            this.tableModelInfo.map(x=>{
              x.serialNo = filteredValue;
              return x
            });
            this.modelGridOptions.api.redrawRows({ rowNodes: params });
          }
        },
        modelItemGridCellValueChange(params) {
          if(params.colDef.field === 'changeSerialNo'){
            const inputValue = params.newValue || '';
            const filteredValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
            params.data.value = filteredValue;

            this.tableChangeModel.map(x=>{
              x.changeSerialNo = filteredValue;
              return x
            });
            this.modelItemGridOptions.api.redrawRows({ rowNodes: params });
          }
        },
    }
}
</script>